import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AlertConfigSummary } from '../AlertConfigSummary';
import { DGPTAlertConfig } from '../../../types/dgptAlerts';
import { CreateAlertConfigPayload } from '../hooks/useAlertConfigs';

const TestFinalizeStep = () => {
  const form = useFormContext();
  const currentData = form.getValues() as CreateAlertConfigPayload;

  return (
    <div className="d-flex flex-column gap-3">
      <h6>Review Configuration</h6>
      <p className="text-muted">
        Review your alert configuration details below. Once you&apos;re
        satisfied, click &quot;Create Configuration&quot; to save and activate.
      </p>
      <AlertConfigSummary config={currentData as DGPTAlertConfig} />
    </div>
  );
};

export default TestFinalizeStep;
